import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { AppInput } from "../../../../shared/components/AppInput";
import { selectSelectedClassifier } from "../../redux/selectors";
import styles from "./styles.module.css";

interface Props {
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	name: string;
}

export const ClassCommonSetting: React.FC<Props> = ({ name, onChange }) => {
  const selectedClassifier = useAppSelector(selectSelectedClassifier);

  const { t } = useTranslation();

  return (
    <div className={styles["common-setting-container"]}>
      <AppInput
        value={name}
        onChange={onChange}
        className={styles.input}
        small
        placeholder={t("classification.input_name_placeholder")}
      />
    </div>
  );
};
